<template>
    <div>
        <!-- <el-input placeholder="标签关键字"/> -->
        <!-- <div @click="dialogVisible = true" style="cursor: pointer; margin: 15px 0;" v-if="isShow">+新增标签组</div> -->
        <el-button @click="dialogVisible = true" v-if="isShow" type="primary" size="small" style="margin-left: 8px;">+ 新增标签组</el-button>
        <el-scrollbar :style="{height: isShow ? '700px' : '500px'}">
        <div class="group" v-for="(item, i) in groupList">
            <div :class="isShow ? 'title' : 'title1'">{{ item.groupName }} <span style="color: #fff;" @click="delTagGroup(item.groupId)">X</span></div>
            <div>
                <el-tag
                    :key="item.tagId"
                    v-for="tag in item.groupChatTagDetailDtoList"
                    :closable="isShow"
                    :disable-transitions="false"
                    @close="deleteGroupTag(tag.tagId)"
                    @click="handleClick(tag)"
                    :type="tag.type == 1? '' : 'info'"
                    style="cursor: pointer;"
                  >
                    {{tag.tagName}}
                </el-tag>
                
                <!-- <el-check-tag checked="true" style="margin-right: 8px" v-for="tag in item.groupChatTagDetailDtoList" type="info" v-else>{{tag.tagName}}</el-check-tag> -->
                <!-- <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    :ref="`saveTagInput`"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                    >
                </el-input> -->
                <el-button class="button-new-tag" size="small" @click="setGroupTagId(item.groupId)" v-if="isShow" type="primary">+ 新建标签</el-button>
            </div>
        </div>
    </el-scrollbar>
        <div style="text-align: right;" v-if="!isShow">
            <el-button @click="handleBack">返回</el-button>
            <el-button type="primary" @click="handleSubmit">确认</el-button>
        </div>
        <el-dialog
            title="新增标签组"
            :visible.sync="dialogVisible"
            width="30%"
            destroy-on-close
            @close="handleDialogClose"
            >
            <el-input placeholder="请输入标签组名" maxlength="20" show-word-limit v-model="groupItem"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="createGroupTag" :disabled="groupItem.length == 0">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="新增群标签"
            :visible.sync="groupTagVisible"
            width="30%"
            destroy-on-close
            @close="handleDialogClose"
            >
            <el-input placeholder="请输入标签名" maxlength="20" show-word-limit v-model="groupTag"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="groupTagVisible = false">取 消</el-button>
                <el-button type="primary" @click="createTag" :disabled="groupTag.length == 0">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {createTag, deleteGroupTag,getTagList,createGroupTag,delTagGroup} from '../../api/group/index.js'
    export default {
        mounted(){
            this.getTagList()
        },
        props: {
            isShow: {
                type: Boolean,
                default: true
            }
        },  
        data(){
            return{
                inputVisible: false,
                inputValue: '',
                dynamicTags: [],
                dialogVisible: false,
                groupTagVisible: false,
                groupItem: '',//群标签
                groupList:[], //群标签组列表
                groupTag: '', //子标签
                groupId: '', //当前群标签Id
            }
        },
        methods: {
            handleSubmit(){
                this.$emit('addTag', this.groupList)
            },
            handleBack(){
                this.$emit('handleBack')
            },
            handleDialogClose(){
                this.groupItem = ''
                this.groupTag = ''
                this.groupId = ''
            },
            handleClick(e){
                if(e.type == undefined || e.type == 0){
                    e.type = 1
                }else{
                    e.type = 0
                }
                // 点击之后强制刷新
                this.$forceUpdate()
            },
               // 新建标签组
            createGroupTag(){
             createGroupTag(localStorage.getItem("Authorization"), this.groupItem).then(res=>{
                this.dialogVisible = false
                this.getTagList()
             })
            },
            getTagList(){
                // 获取群标签组
                 getTagList(localStorage.getItem("Authorization")).then(res=>{
                    if(res.error.code == 200){
                        this.groupList = res.data
                    }
                 })
            },
            // 创建群标签组子标签
            createTag(){
                createTag(localStorage.getItem("Authorization"), {groupId: this.groupId,tagName: this.groupTag }).then(res=>{
                    this.groupTagVisible = false
                    this.getTagList()
                })
            },
            setGroupTagId(id){
               this.groupTagVisible = true
               this.groupId = id 
            },
            deleteGroupTag(id){
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                    deleteGroupTag(localStorage.getItem("Authorization"), id).then(res=>{
                        this.getTagList()
                        this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    })
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                    });
            },
            // 删除标签组
            delTagGroup(id){
                this.$confirm('确认删除该标签组吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        delTagGroup(id,localStorage.getItem("Authorization")).then(res=>{
                        this.getTagList()
                        this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    })
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                    });
            },
            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                this.dynamicTags.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
          },
          handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            },
            

        showInput(i) {
            console.log(i)
            this.inputVisible = true;
            console.log(`this.$refs.saveTagInput${i}`)
            // console.log(this.$refs.saveTagInput1)
            this.$nextTick(_ => {
                // console.log( this.$refs.saveTagInput2)
            `this.$refs.saveTagInput[${i}].$refs.input.focus()`;
           
            });
        },

        }
    }
</script>

<style lang="scss" scoped>
    .group {
        margin: 15px 10px;
        .title {
            margin-bottom: 10px;
            cursor: pointer;
            padding: 6px;
            
            // &:hover::after{
            //     content: 'x';
            //     margin-left: 5px;
            //     color: #aaa;
            // }
            &:hover {
                background: #f4f4f5;
                display: inline-block;
                span {
                margin-left: 5px;
                font-size: 14px;
                color: #9093a5 !important;
            }
            }
        }
        .title1 {
            margin-bottom: 10px;
            padding: 6px;
         }
        .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
    }

</style>